import type { Tagged } from 'type-fest';
import type { Account } from '../account';
import { MutableEntity } from '../common';
import { MongoId } from '../MongoId';
import { Project } from '../project';
export type ProjectKarteMapping = MutableEntity & {
  rtProjectId: Project.Id;
  karteProjectId: ProjectKarteMapping.KarteProjectId;
  karteApiKey?: ProjectKarteMapping.KarteApiKey;
};

export namespace ProjectKarteMapping {
  export type KarteProjectId = MongoId;
  export namespace KarteProjectId {
    export const FromString = (id: string): KarteProjectId => MongoId.FromString(id) as KarteProjectId;
  }

  export type KarteApiKey = Tagged<string, 'KarteApiKey'>;
  export namespace KarteApiKey {
    export const FromString = (key: string): KarteApiKey => key as KarteApiKey;
  }

  export type Props = MutableEntity.Props & {
    rtProjectId: string;
    karteProjectId: string;
    karteApiKey?: string;
  };

  export const Construct = (props: Props): ProjectKarteMapping => {
    return {
      ...MutableEntity.Construct(props),
      rtProjectId: Project.Id.FromString(props.rtProjectId),
      karteProjectId: KarteProjectId.FromString(props.karteProjectId),
      karteApiKey: props.karteApiKey ? KarteApiKey.FromString(props.karteApiKey) : undefined,
    };
  };

  export namespace Create {
    export type Props = Pick<ProjectKarteMapping, 'rtProjectId' | 'karteProjectId'> & { karteApiKey: ProjectKarteMapping.KarteApiKey };
    export type Params = {
      operatorId: Account.Id;
      props: Props;
    };
  }
  export const Create = ({ operatorId, props }: Create.Params): ProjectKarteMapping => {
    return {
      ...MutableEntity.Create({ operatorId }),
      rtProjectId: props.rtProjectId,
      karteProjectId: props.karteProjectId,
      karteApiKey: props.karteApiKey,
    };
  };

  export namespace Update {
    export type UpdatableKey = 'karteProjectId' | 'karteApiKey';
    export type UpdateProps = Partial<Pick<ProjectKarteMapping, UpdatableKey>>;
    export type Params = {
      operatorId: Account.Id;
      cur: ProjectKarteMapping;
      updateProps: UpdateProps;
    };
  }
  export const Update = ({ operatorId, cur, updateProps }: Update.Params): ProjectKarteMapping => {
    return {
      ...cur,
      ...MutableEntity.Update({ cur, operatorId }),
      ...updateProps,
    };
  };
}
